import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import IconControl from './icon-control'
import colours from '../lib/colours'

const SkinnyStyledButton = styled.button`
  min-width: 100px !important;
  height: 40px;
`

const SimpleButton = styled(SkinnyStyledButton)`
  background: rgba(0, 0, 0, 0) !important;
  border-color: rgba(0, 0, 0, 0) !important;
  color: ${colours.darkPurple} !important;
`

interface IProps {
  text: string
  icon?: string
  onClick: any
}

const SimpleButtonControl = (props: PropsWithChildren<IProps>) => {
  return (
    <SimpleButton className="btn btn-primary" {...props}>
      {props.icon ? <span style={{ paddingRight: 8 }}>{props.icon ? <IconControl icon={props.icon} /> : ''}</span> : ''}
      {props.text}
    </SimpleButton>
  )
}

export default SimpleButtonControl
